import {
  LEARN_OG_IMAGE,
  SITE_ORIGIN,
  canonicalLearnUrl,
  normalizeLearnContentPath,
  privateLearnRoute,
} from "../utils/learnRoutes";
import { PRIMEROS_GUIDES } from "./learn/es-primeros";
import { OFFICIAL_RULES_ES, REGLAS_GUIDES } from "./learn/es-reglas";
import { MODOS_GUIDES } from "./learn/es-modos";
import { PARTIDAS_GUIDES } from "./learn/es-partidas";
import { COMUNIDAD_GUIDES } from "./learn/es-comunidad";
import { ESTRATEGIA_GUIDES } from "./learn/es-estrategia";
import { AYUDA_GUIDES } from "./learn/es-ayuda";
import { EN_GUIDES } from "./learn/en-guides";
import { ARTICULOS_GUIDES } from "./learn/es-articulos";
import { PARTIDAS_COMENTADAS_GUIDES } from "./learn/es-partidas-comentadas";
import { RU_GUIDES } from "./learn/ru-guides";
import { DE_GUIDES } from "./learn/de-guides";

// Aprender reescrito el 2026-10-18: las 286 páginas que hizo Codex (muchas repetidas, sin tildes y
// escritas para el programador) se juntaron en unas 70 guías completas. Cada dirección vieja sigue
// funcionando: `legacy` la lleva a la guía nueva (aquí como alias y en nginx con un 301).

export const LEARN_LAST_UPDATED = "2026-10-18";
export { OFFICIAL_RULES_ES };

export const LEARN_DIAGRAMS = {
  "partida-power-adrianwrj-12": {
    src: "/learn-diagrams/partida-power-adrianwrj-12.svg",
    width: 528,
    height: 562,
    alt: { es: "Tablero de XIMA visto desde arriba en la partida power contra adrianwrj. 6... A12D9: el bloque rojo usa el de B11 como escalón y sube al segundo piso, en D9." },
    caption: { es: "6... A12D9: el bloque rojo usa el de B11 como escalón y sube al segundo piso, en D9." },
  },
  "partida-power-adrianwrj-14": {
    src: "/learn-diagrams/partida-power-adrianwrj-14.svg",
    width: 528,
    height: 562,
    alt: { es: "Tablero de XIMA visto desde arriba en la partida power contra adrianwrj. 7... D9xB11: dos rojos contra un azul en B11; el bloque azul queda capturado." },
    caption: { es: "7... D9xB11: dos rojos contra un azul en B11; el bloque azul queda capturado." },
  },
  "partida-power-adrianwrj-40": {
    src: "/learn-diagrams/partida-power-adrianwrj-40.svg",
    width: 528,
    height: 562,
    alt: { es: "Tablero de XIMA visto desde arriba en la partida power contra adrianwrj. 20... C9C10: un bloque rojo se sube encima del especial azul de C10 y lo deja sin poder moverse." },
    caption: { es: "20... C9C10: un bloque rojo se sube encima del especial azul de C10 y lo deja sin poder moverse." },
  },
  "partida-power-adrianwrj-52": {
    src: "/learn-diagrams/partida-power-adrianwrj-52.svg",
    width: 528,
    height: 562,
    alt: { es: "Tablero de XIMA visto desde arriba en la partida power contra adrianwrj. 26... =F7: el especial rojo entra por A7 y sube usando los bloques de B7 y D7 hasta el tercer piso." },
    caption: { es: "26... =F7: el especial rojo entra por A7 y sube usando los bloques de B7 y D7 hasta el tercer piso." },
  },
  "partida-power-adrianwrj-63": {
    src: "/learn-diagrams/partida-power-adrianwrj-63.svg",
    width: 528,
    height: 562,
    alt: { es: "Tablero de XIMA visto desde arriba en la partida power contra adrianwrj. 32. E8xC10: dos azules contra un rojo; power captura y libera a su especial." },
    caption: { es: "32. E8xC10: dos azules contra un rojo; power captura y libera a su especial." },
  },
  "partida-power-adrianwrj-78": {
    src: "/learn-diagrams/partida-power-adrianwrj-78.svg",
    width: 528,
    height: 562,
    alt: { es: "Tablero de XIMA visto desde arriba en la partida power contra adrianwrj. 39... F6G6: el especial rojo se sube a su propio bloque en G6, al lado de la cima." },
    caption: { es: "39... F6G6: el especial rojo se sube a su propio bloque en G6, al lado de la cima." },
  },
  "partida-power-adrianwrj-80": {
    src: "/learn-diagrams/partida-power-adrianwrj-80.svg",
    width: 528,
    height: 562,
    alt: { es: "Tablero de XIMA visto desde arriba en la partida power contra adrianwrj. 40... G6G7: el especial rojo llega a la cima y gana adrianwrj." },
    caption: { es: "40... G6G7: el especial rojo llega a la cima y gana adrianwrj." },
  },
  "tablero-vista-superior": {
    src: "/learn-diagrams/tablero-vista-superior.svg",
    width: 640,
    height: 640,
    alt: {
      es: "Tablero de XIMA visto desde arriba: 13 × 13 casillas de A1 a M13, con el primer, segundo y tercer piso en colores y la cima en G7",
      en: "XIMA board seen from above: 13 × 13 squares from A1 to M13, with the first, second and third floors coloured and the summit on G7",
    },
    caption: {
      es: "Vista superior: cada color es un piso. La cima es G7, en el centro.",
      en: "Top view: each colour is a floor. The summit is G7, in the centre.",
    },
  },
  "tablero-vista-lateral": {
    src: "/learn-diagrams/tablero-vista-lateral.svg",
    width: 720,
    height: 360,
    alt: {
      es: "Corte lateral de la pirámide de XIMA: cuatro pisos, cada uno dos alturas de bloque más alto que el anterior",
      en: "Side cut of the XIMA pyramid: four floors, each two block-heights above the previous one",
    },
    caption: {
      es: "Vista lateral: cada piso está dos alturas de bloque por encima del anterior.",
      en: "Side view: each floor is two block-heights above the previous one.",
    },
  },
  "subir-con-escalon": {
    src: "/learn-diagrams/subir-con-escalon.svg",
    width: 720,
    height: 480,
    alt: {
      es: "Ejemplo de subida en XIMA: un bloque en A1 pasa por encima de un escalón en B2 y llega a C3, en el segundo piso",
      en: "Climbing example in XIMA: a block on A1 passes over a step on B2 and lands on C3, on the second floor",
    },
    caption: {
      es: "De A1 a C3 en un movimiento: el bloque de B2 hace de escalón.",
      en: "From A1 to C3 in one move: the block on B2 acts as a step.",
    },
  },
  "dominacion-captura": {
    src: "/learn-diagrams/dominacion-captura.svg",
    width: 760,
    height: 370,
    alt: {
      es: "Tres columnas de bloques: un azul sobre un rojo (dominación), dos azules con un rojo en medio (captura) y un azul sobre dos rojos (solo dominación)",
      en: "Three columns of blocks: one blue on one red (domination), two blues with a red between them (capture) and one blue on two reds (domination only)",
    },
    caption: {
      es: "1 contra 1 domina; 2 contra 1 captura; 1 contra 2 solo domina.",
      en: "1 against 1 dominates; 2 against 1 captures; 1 against 2 only dominates.",
    },
  },
  "incorporar-bloque": {
    src: "/learn-diagrams/incorporar-bloque.svg",
    width: 640,
    height: 400,
    alt: {
      es: "Cómo se incorpora un bloque en XIMA: entra por una casilla del borde y avanza de frente o en diagonal hacia el centro, nunca de lado",
      en: "How a block enters the XIMA board: from an edge square, moving straight in or diagonally towards the centre, never sideways",
    },
    caption: {
      es: "Se entra por el borde: de frente o en diagonal, nunca de lado.",
      en: "Blocks enter from the edge: straight in or diagonally, never sideways.",
    },
  },
  "caras-y-casillas": {
    src: "/learn-diagrams/caras-y-casillas.svg",
    width: 640,
    height: 640,
    alt: {
      es: "Casillas con nombre del tablero de XIMA: esquinas exteriores e interiores, centrales y diagonales superiores hacia G7",
      en: "Named squares on the XIMA board: outer and inner corners, central lines and upper diagonals towards G7",
    },
    caption: {
      es: "Esquinas, centrales y diagonales superiores: las líneas que llevan a la cima.",
      en: "Corners, central lines and upper diagonals: the lines that lead to the summit.",
    },
  },
};

// Temas de la pestaña Guías, en orden. Cada tema se divide en apartados.
export const LEARN_THEME_SPECS = [
  {
    id: "primeros-pasos",
    icon: "🚀",
    label: "Primeros pasos",
    sections: [
      { label: "Empieza aquí", slugs: ["que-es-xima", "como-jugar", "academia", "preguntas-frecuentes"] },
      { label: "Conoce XIMA", slugs: ["historia-de-xima", "glosario"] },
    ],
  },
  {
    id: "reglas",
    icon: "📜",
    label: "Reglas y modos",
    sections: [
      {
        label: "Reglas básicas",
        slugs: [
          "reglas",
          "reglas/tablero-y-casillas",
          "reglas/bloques",
          "reglas/incorporar-bloque",
          "reglas/movimientos",
          "reglas/subir-bloques",
        ],
      },
      {
        label: "Dominar, capturar y ganar",
        slugs: [
          "reglas/dominacion-y-captura",
          "reglas/bloqueo-y-obstruccion",
          "reglas/oposicion-especial",
          "reglas/cima",
          "reglas/rescate",
          "reglas/fin-de-partida",
          "reglas/incremento-de-material",
        ],
      },
      {
        label: "Modos de juego",
        slugs: ["modos-de-juego", "ciencia", "azar", "cienzar", "modos/ciencia-vs-azar", "modos/freebox", "reglas/dados"],
      },
      { label: "Notación", slugs: ["sistema-de-anotacion"] },
    ],
  },
  {
    id: "partidas",
    icon: "🎮",
    label: "Partidas e interfaz",
    sections: [
      {
        label: "Jugar",
        slugs: ["partidas-online", "tutoriales/crear-partida", "tutoriales/unirse-partida-privada", "lobby", "ver-partidos"],
      },
    ],
  },
  {
    id: "historial",
    icon: "🕘",
    label: "Historial y replay",
    sections: [
      { label: "Repasa tus partidas", slugs: ["historial-y-replay", "replay/controles", "analizar-partida", "descargar-video"] },
    ],
  },
  {
    id: "estadisticas",
    icon: "📊",
    label: "Estadísticas y ranking",
    sections: [{ label: "Tu nivel", slugs: ["estadisticas", "estadisticas/cimax", "ranking"] }],
  },
  {
    id: "comunidad",
    icon: "👥",
    label: "Perfil y comunidad",
    sections: [{ label: "Comunidad", slugs: ["perfil", "amigos", "chat-de-voz", "noticias"] }],
  },
  {
    id: "torneos",
    icon: "🏆",
    label: "Torneos",
    sections: [{ label: "Competir", slugs: ["torneos", "campeonato"] }],
  },
  {
    id: "puzzles",
    icon: "🧩",
    label: "Puzzles y bots",
    sections: [{ label: "Entrenar", slugs: ["puzzles", "bots"] }],
  },
  {
    id: "estrategia",
    icon: "♟️",
    label: "Estrategia y libro",
    sections: [
      { label: "Fundamentos", slugs: ["estrategia", "estrategia/valor-de-los-bloques"] },
      { label: "Apertura", slugs: ["estrategia/aperturas-xima", "estrategia/defensas-xima", "estrategia/maniobra-feedback"] },
      { label: "Medio juego", slugs: ["estrategia/medio-juego", "estrategia/maniobra-zil", "reglas/amenazas-al-especial"] },
      { label: "Final", slugs: ["estrategia/finales-xima"] },
      {
        label: "Artículos",
        slugs: [
          "articulos/ciencia-y-azar-en-juegos",
          "articulos/xima-y-el-ajedrez",
          "articulos/alternativas-al-ajedrez",
          "articulos/juegos-de-mesa-cubanos",
          "articulos/juegos-de-estrategia-3d",
          "articulos/juegos-de-estrategia-para-ninos",
          "articulos/juegos-de-mesa-en-familia",
          "articulos/juegos-de-mesa-online-gratis",
        ],
      },
      { label: "Partidas comentadas", slugs: ["articulos/partida-comentada-power-adrianwrj"] },
    ],
  },
  {
    id: "ayuda",
    icon: "🛠️",
    label: "Tienda, ajustes y ayuda",
    sections: [
      { label: "Tienda y Premium", slugs: ["tienda", "premium"] },
      { label: "Ajustes y cuenta", slugs: ["ajustes", "control-por-voz", "compatibilidad-movil", "cuenta"] },
      { label: "Ayuda", slugs: ["soporte", "solucion-de-problemas"] },
    ],
  },
];

const THEME_BY_ID = new Map(LEARN_THEME_SPECS.map((theme) => [theme.id, theme]));

const GUIDE_SPECS = [
  ...PRIMEROS_GUIDES,
  ...REGLAS_GUIDES,
  ...MODOS_GUIDES,
  ...PARTIDAS_GUIDES,
  ...COMUNIDAD_GUIDES,
  ...ESTRATEGIA_GUIDES,
  ...AYUDA_GUIDES,
  ...ARTICULOS_GUIDES,
  ...PARTIDAS_COMENTADAS_GUIDES,
  ...EN_GUIDES,
  ...RU_GUIDES,
  ...DE_GUIDES,
];

const SPEC_BY_SLUG = new Map(GUIDE_SPECS.map((spec) => [spec.slug, spec]));

const route = (slug) => privateLearnRoute(slug);

const asText = (items) => (Array.isArray(items) ? items.filter(Boolean).join(" ") : String(items || ""));

const sectionPlainText = (section) =>
  [
    asText(section.p),
    asText(section.list),
    (section.defs || []).map(([term, text]) => `${term}: ${text}`).join(" "),
    (section.qa || []).map(([question, answer]) => `${question} ${answer}`).join(" "),
    section.table ? section.table.rows.map((row) => row.join(" ")).join(" ") : "",
    asText(section.after),
  ]
    .filter(Boolean)
    .join(" ")
    .trim();

const labelFor = (slug) => SPEC_BY_SLUG.get(slug)?.nav || SPEC_BY_SLUG.get(slug)?.h1 || slug;

const buildPage = (spec) => {
  const lang = spec.lang || "es";
  const theme = THEME_BY_ID.get(spec.theme);
  const homeLabel = { en: "Learn XIMA", ru: "XIMA на русском", de: "XIMA auf Deutsch" }[lang] || "Aprender";
  const homePath = lang === "es" ? route() : route(lang);
  const breadcrumbs = [{ label: homeLabel, path: homePath }];
  if (lang === "es" && theme) breadcrumbs.push({ label: theme.label, path: `${route()}?tab=guias&tema=${theme.id}` });

  const sections = (spec.sections || []).map((section) => ({
    ...section,
    heading: section.h,
    body: sectionPlainText(section),
  }));

  return {
    slug: spec.slug,
    lang,
    themeId: spec.theme || "",
    navLabel: spec.nav || spec.h1,
    aliases: (spec.legacy || []).map(normalizeLearnContentPath),
    path: route(spec.slug),
    friendlyUrl: canonicalLearnUrl(spec.slug),
    canonicalUrl: canonicalLearnUrl(spec.slug),
    title: spec.title,
    metaDescription: spec.description,
    h1: spec.h1,
    intro: spec.intro,
    sections,
    stepsTitle: spec.steps?.title || "",
    stepsNote: "",
    steps: spec.steps?.items || [],
    examples: [],
    screenshots: [],
    facts: spec.facts || [],
    video: spec.video || "",
    rulesList: spec.rulesList ? "es" : spec.rulesListLang || "",
    faqs: (spec.faqs || []).map(([question, answer]) => ({ question, answer })),
    internalLinks: (spec.related || [])
      .filter((slug) => SPEC_BY_SLUG.has(slug))
      .map((slug) => ({ label: labelFor(slug), path: route(slug) })),
    sectionLinks: (spec.sections || []).flatMap((section) => section.links || []),
    cta: spec.cta ? { label: spec.cta.label, path: route(spec.cta.slug) } : null,
    breadcrumbs,
    // Grupo de idiomas: la guía en español y sus traducciones comparten grupo (hreflang).
    langGroup: lang === "es" ? spec.slug : spec.es === null ? "__home" : spec.es || "",
    alternate: lang === "es" ? spec.en || "" : spec.es || "",
    ogTitle: spec.title,
    ogDescription: spec.description,
    ogImage: `${SITE_ORIGIN}/learn-og/${spec.slug.replace(/\//g, "--")}.png`,
    robots: "index,follow",
    publishedAt: LEARN_LAST_UPDATED,
    updatedAt: LEARN_LAST_UPDATED,
    status: "verified",
    structuredDataType: "Article",
  };
};

export const learnSeoPages = GUIDE_SPECS.map(buildPage);

// Versiones de cada guía en otros idiomas (para hreflang y el selector de idioma).
const PAGES_BY_GROUP = new Map();
learnSeoPages.forEach((learnPage) => {
  if (!learnPage.langGroup) return;
  if (!PAGES_BY_GROUP.has(learnPage.langGroup)) PAGES_BY_GROUP.set(learnPage.langGroup, []);
  PAGES_BY_GROUP.get(learnPage.langGroup).push(learnPage);
});
learnSeoPages.forEach((learnPage) => {
  const group = PAGES_BY_GROUP.get(learnPage.langGroup) || [];
  learnPage.translations = group.length > 1 ? group.map((other) => ({ lang: other.lang, slug: other.slug })) : [];
});
export const LEARN_LANGUAGE_HOMES = { es: "", en: "en", ru: "ru", de: "de" };

export const learnSeoPagesBySlug = new Map();
export const LEARN_LEGACY_REDIRECTS = {};

learnSeoPages.forEach((learnPage) => {
  learnSeoPagesBySlug.set(learnPage.slug, learnPage);
});
// Alias cortos que también existían antes (2026-07) y que no son el slug de ninguna guía.
const EXTRA_LEGACY = {
  "bloque-especial": "reglas/bloques",
  "ciencia-vs-azar": "modos/ciencia-vs-azar",
  cimax: "estadisticas/cimax",
  contrazar: "modos/ciencia-vs-azar",
  "controles-replay": "replay/controles",
  freebox: "modos/freebox",
  "inteligencia-artificial": "bots",
  "modos/azar": "azar",
  "modos/ciencia": "ciencia",
  "partidas-publicas-y-privadas": "partidas-online",
  "partidos-en-vivo": "ver-partidos",
  recompensas: "tienda",
  skins: "tienda",
  spectate: "ver-partidos",
  tablero: "reglas/tablero-y-casillas",
  "tablero-y-casillas": "reglas/tablero-y-casillas",
};

learnSeoPages.forEach((learnPage) => {
  Object.entries(EXTRA_LEGACY)
    .filter(([, target]) => target === learnPage.slug)
    .forEach(([alias]) => learnPage.aliases.push(alias));
  learnPage.aliases.forEach((alias) => {
    if (!alias || learnSeoPagesBySlug.has(alias)) return;
    learnSeoPagesBySlug.set(alias, learnPage);
    LEARN_LEGACY_REDIRECTS[alias] = learnPage.slug;
  });
});

export const getLearnSeoPage = (rawSlug) => {
  const normalizedSlug = normalizeLearnContentPath(rawSlug);
  return learnSeoPagesBySlug.get(normalizedSlug) || null;
};

export const learnEnglishPages = learnSeoPages.filter((learnPage) => learnPage.lang === "en");

const learnNavItem = (slug) => {
  const learnPage = getLearnSeoPage(slug);
  const searchPrimaryText = learnPage
    ? [learnPage.slug, learnPage.h1, learnPage.title, learnPage.navLabel].filter(Boolean).join(" ")
    : slug;
  const searchSecondaryText = learnPage
    ? [
        learnPage.metaDescription,
        learnPage.intro,
        ...learnPage.sections.flatMap((section) => [section.heading, section.body]),
        ...learnPage.faqs.flatMap((faq) => [faq.question, faq.answer]),
      ]
        .filter(Boolean)
        .join(" ")
    : slug;

  return {
    label: learnPage?.navLabel || learnPage?.h1 || slug,
    path: learnPage?.path || route(slug),
    status: "verified",
    searchPrimaryText,
    searchSecondaryText,
  };
};

// Un grupo por apartado de cada tema (themeId dice a qué tema pertenece).
export const learnCompleteNavigationGroups = LEARN_THEME_SPECS.flatMap((theme) =>
  theme.sections.map((section) => ({
    label: section.label,
    themeId: theme.id,
    items: section.slugs.filter((slug) => SPEC_BY_SLUG.has(slug)).map(learnNavItem),
  }))
);

export const learnSeoNavigation = learnCompleteNavigationGroups.flatMap((group) =>
  group.items.map((item) => ({ label: item.label, path: item.path }))
);

// Nombres antiguos que todavía importa algún archivo.
export const learnExpandedNavigationGroups = learnCompleteNavigationGroups;
export const learnThirdHundredNavigationGroups = [];
export const learnBookNavigationGroups = [];

export const LEARN_PAGE_STATUS = {
  verified: "Guía disponible",
  partial: "Guía disponible",
  ownerConfirmation: "Guía disponible",
};

export const learnSiteOrigin = SITE_ORIGIN;
